<template>
  <div>
    <div class="megatabs__row">
      <div class="megatabs__tab megatabs__tab--left" :class="{active: active==1}" @click="active=1">
        <span>CoolManagement System</span>
        <strong>{{ pl ? 'Poznaj nowy 3-strefowy system chłodzenia' : 'Meet the new 3-zone cooling system.' }}</strong>
        <p>
          {{
            pl
            ? 'Chcesz mieć pod pełną kontrolą swoją lodówkę? To możliwe dzięki Amica CoolManagement System. 3-strefowy system chłodzenia pozwala na niezależne ustawienie poziomu temperatur w obrębie chłodziarki, specjalnej szuflady AdaptZone oraz zamrażarki.'
            : 'If you want to have full control of your fridge, the Amica CoolManagement System does it. A 3-zone cooling system allows to set temperatures independently in the fridge, a special AdaptZone drawer and the freezer.'
          }}
        </p>
        <button class="megabtn megabtn-left">
          <svg viewBox="0 0 57 56" xmlns="http://www.w3.org/2000/svg"><path d="M57,0l-47.036,0c-5.503,0 -9.964,4.461 -9.964,9.964c0,10.18 0,25.896 0,36.075c0,5.501 4.46,9.961 9.961,9.961c16.339,0 47.039,0 47.039,0l0,-56Z" fill="#ededed"></path></svg>
          <svg viewBox="0 0 57 56" xmlns="http://www.w3.org/2000/svg" style="stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 1.5;"><path d="M31.796,20.954l-7.169,6.878l7.024,7.214" style="fill: none; stroke: rgb(202, 202, 202); stroke-width: 3.47px;"></path></svg>
        </button>
      </div>
      <div
        class="megatabs__tab megatabs__tab--right"
        :class="{active: active==2}"
        @click="active=2"
      >
        <span>SpaceManagement System</span>
        <strong>{{ pl ? 'Odkryj doskonałą organizację lodówki' : 'Discover perfect organisation in a fridge.' }}</strong>
        <p>
          {{
            pl
            ? 'W lodówkach Amica znajdziesz mnóstwo ułatwień, które wykorzystasz w zależności od codziennych potrzeb. Sprytne rozwiązania pomogą Ci właściwie przechowywać produkty, dzięki czemu w Twojej kuchni nic się nie zmarnuje.'
            : 'Amica fridges offer lots of enhancements tailored to your daily needs. Smart solutions will help you with storing products and enjoying zero waste in your kitchen.'
          }}
        </p>
        <button class="megabtn megabtn-right">
          <svg viewBox="0 0 57 56" xmlns="http://www.w3.org/2000/svg"><path d="M57,0l-47.036,0c-5.503,0 -9.964,4.461 -9.964,9.964c0,10.18 0,25.896 0,36.075c0,5.501 4.46,9.961 9.961,9.961c16.339,0 47.039,0 47.039,0l0,-56Z" fill="#ededed"></path></svg>
          <svg viewBox="0 0 57 56" xmlns="http://www.w3.org/2000/svg" style="stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 1.5;"><path d="M31.796,20.954l-7.169,6.878l7.024,7.214" style="fill: none; stroke: rgb(202, 202, 202); stroke-width: 3.47px;"></path></svg>
        </button>
      </div>
    </div>
    <div class="megatabs__content">
      <component
        :is="windowWidth > 1200 ? 'PanelLeft' : 'PanelLeftMobile'"
        :component_data="component_data.params.left"
        class="megatabs__panel"
        :class="{'panel--active': active==1}"
      />
      <component
        :is="windowWidth > 1200 ? 'PanelRight' : 'PanelRightMobile'"
        :component_data="component_data.params.right"
        class="megatabs__panel"
        :class="{'panel--active': active==2}"
      />
    </div>
  </div>
</template>

<script>
import PanelLeft from "./MainPanelLeft";
import PanelRight from "./MainPanelRight";
import PanelLeftMobile from "./MainPanelLeftMobile";
import PanelRightMobile from "./MainPanelRightMobile";


const getWindowWidth = () => window.innerWidth;

export default {
  props: ["component_data"],
  data() {
    return {
      active: 1,
      windowWidth: getWindowWidth(),
    };
  },
  components: {
    PanelLeft,
    PanelRight,
    PanelLeftMobile,
    PanelRightMobile,
     
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = getWindowWidth();
    });
  },
  destroyed() {
    window.removeEventListener("resize", () => {
      this.windowWidth = getWindowWidth();
    });
  },
};
</script>

<style type="scss">
.recommended_products {
  padding-top: 60px;
  background: #fff;
  z-index: 3;
}
</style>

<style lang="scss" scoped>
@mixin rwd {
  @media screen and (max-width: 1200px) {
    @content;
  }
}

html,
body {
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
}

.recommended_products {
  padding-top: 60px;
  background: #fff;
  z-index: 3;
}

.header_main {
  position: relative;
  z-index: 2;
  margin-bottom: 0px !important;
  border-bottom: 2.8rem #fff solid;
}

.megatabs__row {
  display: flex;
  background: #e8e6e1;
  z-index: 2;
  position: relative;
  border-bottom: #ab091e solid 4px;
}

.megatabs__tab {
  width: 50%;
  padding: 2em;
  padding-left: 10em;
  display: flex;
  flex-direction: column;
  color: #625d52;
  cursor: pointer;
  font-size: 24px;
  position: relative;

  .megabtn {
    position: absolute;
    top: 50%;
    width: 57px;
    height: 56px;
    border: none;
    border-radius: 10px 0 0 10px;

    &:hover,
    &:active {
      outline: none;
    }

    @media only screen and (max-width: 1200px) {
      display: none;
    }

    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 57px;
      height: 56px;
    }

    &.megabtn-left {
      right: 0px;
      transform: translateY(-50%);
    }

    &.megabtn-right {
      left: 0px;
      transform: translateY(-50%) rotate(180deg);
    }
  }

  @include rwd {
    font-size: 16px;
    padding: 1.5em;
  }

  span {
    font-size: 1em;
    font-weight: 400;
  }

  strong {
    font-size: 1em;
    font-weight: 600;
    line-height: normal;
    padding-top: 1rem;
    padding-bottom: 1rem;
    @include rwd {
      line-height: normal;
      margin-top: 5px;
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }

  p {
    font-size: 0.7em;
    line-height: 26px;
    font-weight: 300;
    width: 80%;

    @include rwd {
      display: none;
    }
  }
}

.megatabs__tab.active {
  color: #fff;
  background-image: linear-gradient(180deg, #e41429 0%, #ab091e 100%);
  background-position: center bottom 20px;
  background-repeat: no-repeat;
  background-color: #ab091e;
  position: relative;
  border-radius: 0 20px 0 0;

  .megabtn {
    svg:first-child {
      path {
        fill: #e8e6e1;
      }
    }
  }
}
.megatabs__tab.active::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: inherit;
  right: -20px;
  bottom: 0;
  background-image: radial-gradient(
    #e8e6e1 19.5px,
    transparent 20.5px
  ); /* Przesunięcie o 0.5px daje fajny antyaliasing. Inaczej mogą wyjść brzydkie "schody" */
  background-size: 40px 40px;
  background-position: left bottom;
  pointer-events: none;
}
.megatabs__tab:last-child.active {
  border-radius: 20px 0 0 0;
}
.megatabs__tab:last-child.active::after {
  background-position: right bottom;
  right: auto;
  left: -20px;
}
.megatabs__content {
  display: flex;
  max-width: 100vw;
  position: relative;
  overflow: hidden;
  @include rwd {
    margin-top: 70px;
  }
}
.megatabs__panel {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
  font-family: "Uni Neue";
  width: 100%;
  flex-shrink: 0;
}
.megatabs__panel.panel--active {
  position: relative;
  opacity: 1;
  pointer-events: auto;
}
</style>
